export function patchAccessibilityForIziButton(container) {
  const waitForShadowRoot = () =>
    new Promise((resolve) => {
      const maxAttempts = 30;
      let attempt = 0;

      const interval = setInterval(() => {
        const iziButton = container.querySelector("inpost-izi-button");

        if (iziButton?.shadowRoot) {
          clearInterval(interval);
          resolve(iziButton.shadowRoot);
        }

        if (++attempt >= maxAttempts) {
          clearInterval(interval);
          resolve(null);
        }
      }, 100);
    });

  waitForShadowRoot().then((shadowRoot) => {
    if (!shadowRoot) return;

    const innerButton = shadowRoot.querySelector(".button");
    if (!innerButton) return;

    const iziButton = container.querySelector("inpost-izi-button");
    const languageAttr = iziButton.getAttribute("language")?.trim().toLowerCase();
    const lang = languageAttr === "pl" ? "pl" : "en";
    const ariaLabel = lang === "pl" ? "Kup z InPost" : "Buy with InPost";

    innerButton.setAttribute("tabindex", "0");
    innerButton.setAttribute("role", "button");
    innerButton.setAttribute("aria-label", ariaLabel);
    innerButton.setAttribute("lang", lang);

    if (!innerButton.dataset.keyboardHandlerAdded) {
      innerButton.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          innerButton.click();
        }
      });
      innerButton.dataset.keyboardHandlerAdded = "1";
    }
  });
}